// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .p-tabview .p-tabview-panels .price-tab-panel {
  padding: 0 !important;
}

::ng-deep .p-tabview .p-tabview-panels {
  padding: 0 !important;
}

.invoice-dialog {
  font-family: Arial, sans-serif;
  color: #333;
}

.page {
  width: 200mm;
  min-height: 286mm;
  padding: 0;
  margin: 0;
  background: white;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.invoice-header, .invoice-footer {
  text-align: center;
  margin-bottom: 20px;
}

.invoice-header h2, .invoice-header h3 {
  margin: 0;
}

table {
  width: 100%;
  border-collapse: collapse;
  page-break-inside: auto;
}

th, td {
  border: 1px solid #ccc;
  padding: 4px;
  font-size: 12px;
}

th {
  background-color: #f2f2f2;
}

@media print {
  body, .page {
    margin: 0;
    box-shadow: none;
  }
  .page {
    page-break-after: always;
  }
  table, th, td {
    font-size: 11px;
  }
  .print-mb-bt {
    padding-bottom: 1mm !important;
    display: block !important;
    margin: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/myaccount/myaccount.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,8BAAA;EACA,WAAA;AACJ;;AAEA;EACI,YAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AACJ;;AAEA;EACI,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,SAAA;AACJ;;AAEA;EACI,WAAA;EACA,yBAAA;EAEA,uBAAA;AAAJ;;AAGA;EACI,sBAAA;EACA,YAAA;EACA,eAAA;AAAJ;;AAGA;EACI,yBAAA;AAAJ;;AAGA;EACI;IACI,SAAA;IACA,gBAAA;EAAN;EAGE;IACI,wBAAA;EADN;EAIE;IACI,eAAA;EAFN;EAIE;IACI,8BAAA;IACA,yBAAA;IACA,oBAAA;EAFN;AACF","sourcesContent":["::ng-deep .p-tabview .p-tabview-panels .price-tab-panel {\r\n    padding: 0 !important;\r\n}\r\n\r\n::ng-deep .p-tabview .p-tabview-panels {\r\n    padding: 0 !important;\r\n}\r\n\r\n.invoice-dialog {\r\n    font-family: Arial, sans-serif;\r\n    color: #333;\r\n}\r\n\r\n.page {\r\n    width: 200mm;\r\n    min-height: 286mm;\r\n    padding: 0;\r\n    margin: 0;\r\n    background: white;\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 10px;\r\n}\r\n\r\n.invoice-header, .invoice-footer {\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.invoice-header h2, .invoice-header h3 {\r\n    margin: 0;\r\n}\r\n\r\ntable {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    //margin-bottom: 15px;\r\n    page-break-inside: auto;\r\n}\r\n\r\nth, td {\r\n    border: 1px solid #ccc;\r\n    padding: 4px;\r\n    font-size: 12px;\r\n}\r\n\r\nth {\r\n    background-color: #f2f2f2;\r\n}\r\n\r\n@media print {\r\n    body, .page {\r\n        margin: 0;\r\n        box-shadow: none;\r\n    }\r\n\r\n    .page {\r\n        page-break-after: always;\r\n    }\r\n\r\n    table, th, td {\r\n        font-size: 11px;\r\n    }\r\n    .print-mb-bt {\r\n        padding-bottom: 1mm !important;\r\n        display: block !important;\r\n        margin: 0 !important;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
